export enum EChangeRequestStatus {
  CREATED = 'CREATED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  _UNKOWN_ = '_UNKOWN_',
}
